// extracted by mini-css-extract-plugin
module.exports = {"total":"total_price_total__1Zlvg"};